import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import styles from './TourSelection.module.css';

type TProps = {
  name: string;
  description: string;
  onClick: () => void;
};

export const TourSelection = ({ name, description, onClick }: TProps) => {
  return (
    <div className={styles.container}>
      <div>
        <h5 className={styles.name}>{name}</h5>
        <p className={styles.description}>{description}</p>
      </div>
      <Button size="small" onClick={onClick}>
        <Trans>Start tour</Trans>
      </Button>
    </div>
  );
};
